import * as _ from 'lodash';
import * as angular from 'angular';
import * as moment from 'moment';
import {IDatatypeResource} from "../../core/services/DatatypeService";
import {IMinistryResource} from "../../core/services/MinistryService";
import {IClassificationResource} from "../../core/services/ClassificationService";
export class DatatypeModalComponent implements ng.IComponentOptions {
  public controller: any = DatatypeModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string = /*html*/`
    <div class="modal-header">
      <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <h4 class="modal-title" id="datatypeModal">Add Dataset Type</h4>
    </div>
    <div class="modal-body" style="overflow:scroll">
      <p class="text-small text-warning" ng-show="$ctrl.error.form">Please fill the required fields.</p>
      <form name="$ctrl.datatypeForm" class="form-horizontal">
        <div class="form-group">
          <label for="name" class="col-sm-3 control-label">Name</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="name" placeholder="Name" ng-model="$ctrl.form.display_name" required>
          </div>
        </div>
        <div class="form-group">
          <label for="code" class="col-sm-3 control-label">Code</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="code" placeholder="Code" ng-model="$ctrl.form.code" required>
          </div>
        </div>
        <div class="form-group">
          <label for="desc" class="col-sm-3 control-label">Description</label>
          <div class="col-sm-9">
            <textarea class="form-control" placeholder="Description" ng-model="$ctrl.form.description"></textarea>
          </div>
        </div>
        <div class="form-group">
          <label name="format" class="col-sm-3 control-label">File Format</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="format" placeholder="csv, xls, xlxs" ng-model="$ctrl.form.file_format"  ng-change="$ctrl.genFileName()"/>
          </div>
        </div>
        <div class="form-group">
          <label name="fields" class="col-sm-3 control-label">Variable/Column Name</label>
          <div class="col-sm-9">
            <input type="text" class="form-control" id="fields" placeholder="eg: name, nric, gender" ng-model="$ctrl.form.fields" />
          </div>
        </div>
        <div class="form-group">
          <label for="desc" class="col-sm-3 control-label">Ministry Dataset?</label>
          <div class="col-sm-9">
          <label class="radio-inline">
            <input name="isMinistry" ng-model="$ctrl.form.is_ministry" type="radio" ng-value="true"/> Yes
          </label>
          <label  class="radio-inline">
            <input name="isMinistry" ng-model="$ctrl.form.is_ministry" type="radio" ng-value="false"/> No
          </label>
          </div>
        </div>
        <div class="form-group">
          <label for="ministry" class="col-sm-3 control-label">Ministry</label>
          <div class="col-sm-9">
            <ui-select ng-model="$ctrl.form.ministry" required name="ministry">
              <ui-select-match placeholder="Select Ministry">
                <span ng-bind="$select.selected.display_name"></span>
              </ui-select-match>
              <ui-select-choices repeat="item in ($ctrl.ministries | filter: $select.search)">
                <span ng-bind="item.display_name"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <div class="form-group" ng-if="!$ctrl.form.is_ministry">
          <label for="agency" class="col-sm-3 control-label">Agency</label>
          <div class="col-sm-9">
            <ui-select ng-model="$ctrl.form.agency" required name="agency">
              <ui-select-match placeholder="Select Agency">
                <span ng-bind="$select.selected.display_name"></span>
              </ui-select-match>
              <ui-select-choices repeat="item in ($ctrl.form.ministry.agencies | filter: $select.search)">
                <span ng-bind="item.display_name"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <div class="form-group">
          <label for="category" class="col-sm-3 control-label">Category</label>
          <div class="col-sm-9">
            <ui-select ng-model="$ctrl.form.category" required name="category">
              <ui-select-match placeholder="Select Category">
                <span ng-bind="$select.selected.name"></span>
              </ui-select-match>
              <ui-select-choices repeat="item.name as item in ($ctrl.categories | filter: $select.search)">
                <span ng-bind="item.name"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <div class="form-group">
          <label for="frequency" class="col-sm-3 control-label">Frequency</label>
          <div class="col-sm-9">
            <ui-select ng-model="$ctrl.form.frequency" required name="frequency" ng-change="$ctrl.genFileName()">
              <ui-select-match placeholder="Select Frequency">
                <span ng-bind="$select.selected.name"></span>
              </ui-select-match>
              <ui-select-choices repeat="item.code as item in ($ctrl.frequencies | filter: $select.search)">
                <span ng-bind="item.name"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <div class="form-group">
          <label for="startDate" class="col-sm-3 control-label">Start Date</label>
          <div class="col-sm-9">
            <p class="input-group">
              <input type="text" class="form-control" id="startDate" placeholder="Start Date" uib-datepicker-popup ng-model="$ctrl.form.startDate" is-open="calendar.opened" datepicker-options="$ctrl.dateOptions" ng-required="true" close-text="Close">
              <span class="input-group-btn">
                <button class="btn btn-default" ng-click="calendar.opened=true">
                  <i class="fa fa-fw fa-calendar"></i>
                </button>
              </span>
            </p>
          </div>
        </div>
        <div class="form-group">
          <label for="desc" class="col-sm-3 control-label">Upload Method</label>
          <div class="col-sm-9 m-btm-05">
            <label class="radio-inline">
              <input name="method" ng-model="$ctrl.form.method" type="radio" ng-value="'classic'"/> Classic
            </label>
            <label  class="radio-inline">
              <input name="method" ng-model="$ctrl.form.method" type="radio" ng-value="'ssh'"/> SSH/SCP
            </label>
            <label  class="radio-inline">
              <input name="method" ng-model="$ctrl.form.method" type="radio" ng-value="'ftp'"/> FTP
            </label>
            <label  class="radio-inline">
              <input name="method" ng-model="$ctrl.form.method" type="radio" ng-value="'api'"/> API
            </label>
            <div ng-if="$ctrl.form.method === 'ssh'">
              <div class="row m-btm-05">
                <div class="col-sm-9">
                  <input type="text" class="form-control" id="ssh-host" placeholder="Host" ng-model="$ctrl.form.ssh.host" required/>
                </div>
                <div class="col-sm-3">
                  <input type="number" class="form-control" id="ssh-port" placeholder="Port" ng-model="$ctrl.form.ssh.port" required/> 
                </div>
              </div>
              <input type="text" class="form-control m-btm-05" id="ssh-username" placeholder="Username" ng-model="$ctrl.form.ssh.username" /> 
              <input type="password" class="form-control m-btm-05" id="ssh-password" placeholder="Password" ng-model="$ctrl.form.ssh.password" /> 
              <input type="password" class="form-control m-btm-05" id="ssh-key" placeholder="Private Key" ng-model="$ctrl.form.ssh.privateKey" /> 
              <input type="text" class="form-control m-btm-05" id="ssh-path" placeholder="Path" ng-model="$ctrl.form.ssh.path" required/> 
              <span>Example: {{$ctrl.form.ssh.path}}/{{$ctrl.fileName}}</span>
              <button type="button" class="btn btn-default" ng-show="$ctrl.form.ssh.username" ng-click="$ctrl.testRemote('ssh')" ng-disabled="$ctrl.testing"><i class="fa fa-fw fa-spin fa-spinner" ng-show="$ctrl.testing"></i><i class="fa fa-fw fa-check text-success" ng-show="$ctrl.testSuccess"></i><i class="fa fa-fw fa-times text-danger" ng-show="$ctrl.testFailed"></i>Test Connection</button>
            </div>
            <div ng-if="$ctrl.form.method === 'ftp'" >
              <div class="row m-btm-05">
                <div class="col-sm-9">
                  <input type="text" class="form-control" id="ftp-host" placeholder="Host" ng-model="$ctrl.form.ftp.host" required/>
                </div>
                <div class="col-sm-3">
                  <input type="number" class="form-control" id="ftp-port" placeholder="Port" ng-model="$ctrl.form.ftp.port" required/> 
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 m-btm-05">
                  <label  class="radio-inline">
                    <input name="ftp-secure" ng-model="$ctrl.form.ftp.secure" type="radio" ng-value="true" required/> TLS
                  </label>
                  <label  class="radio-inline">
                    <input name="ftp-secure" ng-model="$ctrl.form.ftp.secure" type="radio" ng-value="false" required/> Non TLS
                  </label>
                </div>
              </div>
              <input type="text" class="form-control m-btm-05" id="ftp-username" placeholder="Username" ng-model="$ctrl.form.ftp.username" required/> 
              <input type="password" class="form-control m-btm-05" id="ftp-password" placeholder="Password" ng-model="$ctrl.form.ftp.password" required/> 
              <input type="text" class="form-control m-btm-05" id="ftp-path" placeholder="Path" ng-model="$ctrl.form.ftp.path" required/> 
              <span>Example: {{$ctrl.form.ftp.path}}/{{$ctrl.fileName}}</span>
              <button type="button" class="btn btn-default" ng-show="$ctrl.form.ftp.username" ng-click="$ctrl.testRemote('ftp')" ng-disabled="$ctrl.testing"><i class="fa fa-fw fa-spin fa-spinner" ng-show="$ctrl.testing"></i><i class="fa fa-fw fa-check text-success" ng-show="$ctrl.testSuccess"></i><i class="fa fa-fw fa-times text-danger" ng-show="$ctrl.testFailed"></i>Test Connection</button>
              <span ng-show="$ctrl.textError">{{$ctrl.textError}}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()">Close</button>
      <button type="button" class="btn btn-primary" ng-click="$ctrl.saveDatatype()" ng-disabled="$ctrl.testing">Save changes</button>
    </div>`;
}

export class DatatypeModalController {
  public static $inject: Array<any> = ["DatatypeService", "MinistryService", "ClassificationService", "$timeout", "$http"];
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public resolve: any;
  public form: any;
  public datatypeForm: any;
  public error: any;
  public ministries: Array<any>;
  public categories: Array<any>;
  public frequencies: Array<any>;
  public dateOptions: any;
  public isEdit: boolean;
  public fileName: string;
  public testing: boolean;
  public testSuccess: boolean;
  public testFailed: boolean;
  public testError: string;
  constructor(private DatatypeService: IDatatypeResource, private MinistryService: IMinistryResource, private ClassificationService: IClassificationResource, private $timeout: ng.ITimeoutService, private $http: ng.IHttpService) {
    this.ministries = MinistryService.query({state: "active", allFields: true});
    this.categories = ClassificationService.query({type: "category", state: "active"});
    this.frequencies = [
      {name: "One Off", code: "o"},
      {name: "Monthly", code: "m"},
      {name: "Quarterly", code: "q"},
      {name: "Annually", code: "a"},
      {name: "Biannually", code: "b"}
    ];
    let maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + 10);
    this.dateOptions = {
      maxDate: maxDate,
      minDate: new Date(),
      startingDay: 1
    }
    this.error = {form: false};
    $timeout(() => {
      if (this.resolve.datatype) {
        this.isEdit = true;
        this.form = this.resolve.datatype;
        this.ministries.$promise.then(() => {
          this.form.ministry = _.find(this.ministries, {_id: this.form.ministry._id})
        })
        this.form.startDate = new Date(this.resolve.datatype.startDate);
        this.form.fields = _.sortBy(this.form.expected_fields, ['sequence']).map((field: {name: string, sequence: number}) => {
          return field.name
        }).join(',')
        if (!this.form.method) {
          this.form.method = 'classic'
        }
        this.genFileName()
      }
      else {
        this.isEdit = false;
        this.form = {
          method: 'classic'
        }
      }
    })
  }
  public cancel() {
    this.modalInstance.dismiss("canceled");
  }
  public saveDatatype() {
    const data = angular.copy(this.form);
    if (data.fields) {
      data.expected_fields = data.fields.split(',').map((field, id) => {
        return {
          name: field.trim(),
          sequence: id
        }
      })
    }
    if (data.agency && data.agency._id)
      data.agency = data.agency._id;
    if (data.ministry._id)
      data.ministry = data.ministry._id;
    if (this.datatypeForm.$invalid || !this.datatypeForm.$dirty)
      this.error.form = true;
    else if (this.isEdit) {
      this.DatatypeService.update({datatypeId: this.form._id}, data)
      .$promise.then((saved) => {
        saved.ministry = this.form.ministry;
        saved.agency = this.form.agency;
        this.modalInstance.close(saved);
      })
    }
    else {
      this.error.form = false;
      let _datatype:IDatatype = new this.DatatypeService(data);
      _datatype.name = _datatype.display_name.split(" ").join("_");
      _datatype.$save().then((saved) => {
        saved.ministry = this.form.ministry;
        saved.agency = this.form.agency;
        this.modalInstance.close(saved);
      })
    }
  }

  public genFileName () {
    if (this.form.frequency && this.form.file_format && this.form.code) {
      const today = moment()
      let partial
      switch(this.form.frequency) {
        case 'a':
        partial = `Y-${today.format('YYYY')}`
        break;
        case 'b': 
        partial = `B1-${today.format('YYYY')}`
        break;
        case 'm': 
        partial = `M-${today.format('MMYYYY')}`
        break;
        case 'q':
        partial = `Q1-${today.format('YYYY')}`
        break;
        case 'o': 
        partial = `OF-${today.format('MMYYYY')}-${today.format('MMYYYY')}`
        break;
      }
      this.fileName = this.form.code + '-' + partial + '.' + this.form.file_format
    }
    else {
      this.fileName = ""
    }
  }

  public testRemote (type) {
    let config, path
    if (type === 'ssh') {
      config = this.form.ssh
      path = this.form.ssh.path
    }
    else if (type === 'ftp') {
      config = this.form.ftp
      path = this.form.ftp.path
    }
    else {
      return
    }
    this.testing = true
    this.testFailed = false
    this.testSuccess = false
    this.$http.post(`${BASE}/api/tools/remote_test`, {type, config, path})
    .then((res) => {
      const data = res.data as any
      if (data.success) {
        this.testSuccess = true
        this.testError = ""
      }
      else {
        this.testFailed = true
        this.testError = data.message
      }
    })
    .finally(() => {
      this.testing = false
    })
  }
}

export interface IDatatype extends ng.resource.IResource<any> {
  name: string;
  display_name: string;
  code: string;
  agency: string;
  ministry: string;
  frequency: string;
  category: string;
  description: string;
  file_format: string;
  expected_fields: {
    name: string
    sequence: number
  }[]
  startDate: Date;
  state: string;
  createdOn: Date;
}
